import { cn } from '@/lib/utils';

export function Badge({
  className,
  tone = 'neutral',
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: 'neutral' | 'accent' | 'danger' | 'warn' }) {
  const tones: Record<string, string> = {
    neutral: 'bg-[var(--surface-2)] text-[var(--text-muted)]',
    accent: 'bg-[var(--accent-soft)] text-[var(--accent)]',
    danger: 'bg-[var(--danger)]/12 text-[var(--danger)]',
    warn: 'bg-[var(--warn)]/12 text-[var(--warn)]',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] font-medium leading-none',
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
